<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
 @font-face {
    /* font-test*/
    font-family: DINEngsbek;
    src: url('/static/fonts/DINEngAlt.ttf');
  }
  #app {
    background-color: #f2f2f4;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue